import { ISP_Pipe } from './types'
import { OperatorPanelWrapperWithChildren } from '../../components/Layout';
import { Badge } from 'baseui/badge';
import { FormattedMessage } from 'react-intl';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { schemaPump } from '../../Devices/DriveOneSpeed/types'
import { schemaPump as schemaPumpVar } from '../../Devices/DriveVarSpeed/types'
import { schema as schemaValveVar } from '../../Devices/ValveVar/types'
import { schema as schemaValveTwoPoint } from '../../Devices/ValveTwoPoint/types'

export function OperatorPanel(props: ISP_Pipe) {

    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const circulationPump = useMemo(() => childElement?.find((v: any) => v.schema === schemaPump), [childElement]);
    const circulationPumpVar = useMemo(() => childElement?.find((v: any) => v.schema === schemaPumpVar), [childElement]);
    const circulationValveVar = useMemo(() => childElement?.find((v: any) => v.schema === schemaValveVar), [childElement]);
    const circulationValveTwoPoint = useMemo(() => childElement?.find((v: any) => v.schema === schemaValveTwoPoint), [childElement]);

    const hasAggregates = circulationPump || circulationPumpVar || circulationValveVar || circulationValveTwoPoint;
    return (
        <OperatorPanelWrapperWithChildren objectId={props.id} resourceGroupId={props.resourceGroupId}
            statusContent={<>
                {hasAggregates && <>
                    {props.isOn && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.ON" defaultMessage="On" />} />}
                    {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
                </>
                }
            </>}>
        </OperatorPanelWrapperWithChildren>
    );
}

